enum UploadTrackingOptions {
	NEW = 'new',
	CHANGE = 'change',
	FIX = 'fix'
}

export { UploadTrackingOptions };
